import React, { useContext, useEffect, useState } from 'react';
import { style } from 'typestyle';
import EmployeeOverviewGroupOfficeManager from './groups/employees-overview-group.component';
import * as styles from './check-in-employees.styles';
import OfficeOverviewGroupOfficeManager from './groups/office-overview-group.component';
import Column from '../../core/components/column/column.component';
import { CrossAxisAlignment } from '../../core/components/flex/flex.component';
import { IsMobileContext } from '../../core/context/is-mobile';
import { useOfficeManagerOrAdminOffices } from '../offices/hooks/offices.hook';
import useUsers from '../offices/hooks/users.hook';
import type Office from '../offices/models/office';
import type PermittedUser from '../offices/models/permitted-user';

const EmployeeOverview = (): React.JSX.Element => {
  const isMobile = useContext(IsMobileContext);

  const officesState = useOfficeManagerOrAdminOffices();
  const [offices, setOffices] = useState<Office[] | undefined>(undefined);
  const [isLoadingOffices, setIsLoadingOffices] = useState(true);
  const [officeSelected, setOfficeSelected] = useState<Office>();
  const usersState = useUsers({ id: officeSelected?.id }).users;
  const [users, setUsers] = useState<PermittedUser[]>([]);
  const [isLoadingUsers, setIsLoadingUsers] = useState(true);

  const handleOfficeChange = (selectedOffice: Office): void => {
    setIsLoadingUsers(true);
    setOfficeSelected(selectedOffice);
  };

  useEffect(() => {
    if (isLoadingOffices && officesState.offices != null) {
      setIsLoadingOffices(false);
      setOffices(officesState.offices);
    }
  }, [officesState, isLoadingOffices]);

  useEffect(() => {
    if (usersState != null) {
      setIsLoadingUsers(false);
      setUsers(usersState);
    }
  }, [usersState]);

  return (
    <div className={style(styles.pageMargin)}>
      <Column className={style(styles.bodyMargin(isMobile))} itemSpacing={50} crossAxisAlignment={CrossAxisAlignment.Stretch}>
        <OfficeOverviewGroupOfficeManager
          allOffices={offices}
          officeChange={handleOfficeChange}
          selectedOfficeId={officeSelected?.id}
          isLoading={isLoadingOffices}
        />
        <EmployeeOverviewGroupOfficeManager selectedOffice={officeSelected} allUsers={users} isLoading={isLoadingUsers} />
      </Column>
    </div>
  );
};

export default EmployeeOverview;
